<flat-header
  headerText="{{
    (sale$ | async)?.statusCode == statusCode.DONE ? headerText : ''
  }}"
></flat-header>

<!-- Content Section -->
<div class="container-lg main-container">
  <div class="row align-items-center mb-4" *ngIf="actionState == 'cancelled'">
    <div class="col-12 col-md-12 col-lg-8 mx-auto">
      <section class="card">
        <div class="card-header bg-success text-center">
          <h2 class="mb-0">
            {{ 'saleModule.orderCanceled' | translate }}
          </h2>
        </div>
        <div class="card-body text-center" role="alert">
          <i
            class="fa fa-check-circle m-4 fa-2x text-success"
            aria-hidden="true"
            role="img"
          ></i>
          <h3 class="text-success" data-test-id="order-canceled-subtitle">
            {{ 'saleModule.orderCanceledSubtitle' | translate }}
            <span *ngIf="hasBalanceCreditedOnCancel(payments$ | async)">
              {{ 'saleModule.orderAmountCredited' | translate }}
              {{
                sale$
                  | async
                  | saleAmountAfterPayments: (payments$ | async)
                  | currency
              }}
            </span>
          </h3>
        </div>
      </section>
    </div>
  </div>

  <div *ngIf="sale$ | async as sale" class="row justify-content-between">
    <div class="col-12 col-sm">
      <h2 data-test-id="sale-id" class="h3">
        {{ 'saleModule.saleId' | translate }}: {{ saleId$ | async }}
      </h2>
      <div *ngIf="sale?.organizationId" class="mb-2 fw-bold">
        {{ 'organizationModule.organization' | translate }}:
        {{ (this.organization$ | async)?.description }}
      </div>
      <div class="mb-2" data-test-id="sale-date">
        {{ 'general.date' | translate }}:
        {{ sale?.date | formatDate: 'd MMM y' | async }}
      </div>
    </div>

    <div class="col-12 col-sm-auto">
      <div *ngIf="(sale | saleFinalStatusCode) !== statusCode.DONE">
        <span class="me-2 mb-0">
          {{ 'general.status' | translate }}
        </span>
        <span
          class="badge bg-soft-primary"
          [ngClass]="{
            'bg-soft-primary': [
              statusCode.INFLIGHT,
              statusCode.PENDING_REQUIRED
            ].includes(sale | saleFinalStatusCode),
            'bg-soft-secondary':
              (sale | saleFinalStatusCode) === statusCode.CANCELLED
          }"
          data-test-id="sale-status-code"
        >
          {{
            'saleModule.statusCode' + (sale | saleFinalStatusCode) | translate
          }}
        </span>
      </div>
      <button
        *ngIf="
          (sale | saleFinalStatusCode) == statusCode.DONE &&
          !sale.isCreditOfSaleId &&
          (saleService.isTicketSale$(sale) | async) &&
          showDownloadTicketsButton &&
          activeTicketingBlockModule
        "
        type="button"
        class="btn btn-soft-primary"
        data-test-id="download-ticket-button"
        (click)="onClickDownloadTicket(sale.id)"
        [disabled]="documentTicketTemplateIsLoading"
      >
        {{ 'general.downloadTicket' | translate }}
      </button>

      <button
        *ngIf="(sale | saleFinalStatusCode) == statusCode.DONE"
        type="button"
        class="btn btn-soft-primary"
        (click)="onClickDownload(sale.id)"
        data-test-id="order-extract-button"
        [disabled]="documentTemplateIsLoading"
      >
        {{ 'employeeModule.orderExtract' | translate }}

        <span
          class="spinner-border spinner-border-sm ms-2"
          role="status"
          *ngIf="documentTemplateIsLoading"
          attr.aria-label="{{ 'wcag.loading' | translate }}"
        >
        </span>
      </button>

      <button
        *ngIf="
          (sale | saleFinalStatusCode) == statusCode.DONE &&
          !sale.isCreditOfSaleId &&
          isCancellable(saleBelongsCourseBookingsInCourse$ | async) &&
          !hasSubscription()
        "
        type="button"
        class="btn btn-soft-primary"
        (click)="onClickCancel()"
        data-test-id="cancel-sale-button"
      >
        {{ 'general.cancel' | translate }}
      </button>
    </div>
    <button
      [hidden]="
        (sale | saleFinalStatusCode) !== statusCode.CANCELLED ||
        (!saleHasCreditSale(sale$ | async) && !(firstCreditSale$ | async)?.id)
      "
      type="button"
      class="btn btn-soft-primary"
      [routerLink]="['/sales', (firstCreditSale$ | async)?.id]"
      data-test-id="credit-sale-button"
    >
      {{ 'saleModule.creditSale' | translate }}
    </button>
    <button
      *ngIf="(sale | saleFinalStatusCode) === statusCode.INFLIGHT"
      type="button"
      class="btn btn-soft-primary"
      [routerLink]="['/sales', sale.id, 'checkout']"
    >
      {{ 'general.pay' | translate }}
    </button>
  </div>

  <sale-item-table-card
    *ngIf="sale$ | async"
    [sale]="sale$ | async"
    [saleItems$]="saleItems$"
  ></sale-item-table-card>

  <payments-table [payments]="payments$ | async"></payments-table>

  <!-- End Row -->
</div>
